export default function NotFoundPage() {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900">404</h1>
        <p className="mt-2 text-xl text-gray-600">Página não encontrada</p>
        <a href="/dashboard" className="btn btn-primary mt-6">
          Voltar ao Dashboard
        </a>
      </div>
    </div>
  )
}
